import { render, staticRenderFns } from "./CustomerAccount.vue?vue&type=template&id=27aeb0e0&scoped=true"
import script from "./CustomerAccount.vue?vue&type=script&lang=ts"
export * from "./CustomerAccount.vue?vue&type=script&lang=ts"
import style0 from "./CustomerAccount.vue?vue&type=style&index=0&id=27aeb0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aeb0e0",
  null
  
)

export default component.exports